import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Globe } from "lucide-react";
import Logo from "@/components/Logo";
import { COMPANY, NAV_LINKS } from "@/data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 bg-[#05090D]" data-testid="site-footer">
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-3 lg:py-20">
        <div>
          <Logo />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-slate-400">
            {COMPANY.fullName} — tecnologie edili dal {COMPANY.founded}. Perforazioni, opere
            strutturali, ingegneria naturalistica e restauro.
          </p>
        </div>

        <nav className="flex flex-col gap-3" data-testid="footer-nav">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-brand-ice">Navigazione</p>
          {NAV_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="w-fit text-sm text-white/70 transition hover:text-brand-ice"
              data-testid={`footer-${l.to === "/" ? "home" : l.to.slice(1)}-link`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex flex-col gap-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-brand-ice">Contatti</p>
          <a href={`https://maps.google.com/?q=${encodeURIComponent("Corso Garibaldi 10, Savoia di Lucania (PZ)")}`} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-sm text-white/70 transition hover:text-brand-ice" data-testid="footer-address-link">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-cyan" />
            {COMPANY.address}
          </a>
          <a href={COMPANY.phoneHref} className="flex items-center gap-3 text-sm text-white/70 transition hover:text-brand-ice" data-testid="footer-phone-link">
            <Phone className="h-4 w-4 shrink-0 text-brand-cyan" />
            {COMPANY.phone}
          </a>
          <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 text-sm text-white/70 transition hover:text-brand-ice" data-testid="footer-email-link">
            <Mail className="h-4 w-4 shrink-0 text-brand-cyan" />
            {COMPANY.email}
          </a>
          <a href={COMPANY.websiteHref} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-white/70 transition hover:text-brand-ice" data-testid="footer-website-link">
            <Globe className="h-4 w-4 shrink-0 text-brand-cyan" />
            {COMPANY.website}
          </a>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-2 px-5 py-6 font-mono text-[10px] uppercase tracking-[0.2em] text-white/35 sm:px-8 md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-copyright">
            © {year} {COMPANY.brand} — {COMPANY.fullName} · Savoia di Lucania (PZ)
          </p>
          <p className="flex items-center gap-3">
            <a
              href="/admin"
              data-testid="footer-admin-link"
              className="transition hover:text-brand-ice"
            >
              Area riservata
            </a>
            <span aria-hidden="true" className="hidden md:inline">
              ·
            </span>
            <span data-testid="footer-designed-by">
              Designed by{" "}
              <a
                href={COMPANY.designedBy.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-designed-by-link"
                className="text-brand-ice transition hover:text-white"
              >
                {COMPANY.designedBy.name}
              </a>
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}
